<script setup>
import PrinterSelect from "../layout/printer-select.vue";
import LocationInput from "./location-input.vue";
import helpers from "@/lib/helpers";
import {onMounted, ref} from "vue";
import {useForm} from "../form/useForm";
import {useDocs} from "@/lib/useDocs";

const props = defineProps({
  url: String
})

const {printDoc} = useDocs();

const location = ref()
const printer = ref()
const save_printer = ref()
const printer_select = ref()
const modal_ref = ref()

const {form, changed, save, state} = useForm(
    ['name', 'cost', 'zone', 'fkwarehouse','receiveto'],
    null,
    location
)

const refresh = async () => {
  location.value = await helpers.asyncAction(props.url, 'GET');
}

onMounted(() => refresh())

const print = () => {
  printDoc(printer.value, 'LabelLocation', location.value._links.label_url, 1, false, {
    printer_type: 'printers.location',
    save_printer: save_printer.value,
  }).then(() => {
    if (save_printer.value)
      printer_select.value.loadSettings()
  })
}

const save_loc = () => save().then(() => modal_ref.value.close())

const deleteLoc = () => {
  helpers.asyncAction(location.value._links.delete_url.href, location.value._links.delete_url.method, {}).then(() => {
    helpers.toast('Location ' + location.value.name + ' deleted.')
    modal_ref.value.close()
  })
}
</script>

<template>
  <modal height="400px" title="Location" ref="modal_ref">
    <template #top>
      <div v-if="location" class="p-2">
        <div class="h5">{{ location.gli }}</div>
        <div>{{ location.name }}</div>
      </div>
    </template>

    <template #footer>
      <b-button variant="outline-danger" size="sm" @click="deleteLoc" class="px-4 mr-2">Delete</b-button>
      <b-button variant="primary" size="sm" class="px-4" @click="save_loc">Update</b-button>
    </template>

    <div v-if="location" class="p-2 d-flex flex-column h-100">
      <div class="flex-fill">
        <modal-row label="Items @ Location" is-text>
          <b-link target="_blank"
                  :to="{name: 'report-run', params: {id: 1}, query: {sloc: true, loc: location.id, chan: false, smodelpart: true}}">
          {{ location.onhand }}
          </b-link>
        </modal-row>
        <modal-row label="Total Weight" is-text>
          {{ location.weight || '' }} {{ location.weight ? 'Lbs' : 'N/A' }}
        </modal-row>
        <location-input v-model="form" :state="state" @enter="save_loc" />
      </div>
      <form-divider />
      <div>
        <modal-row label="Label">
          <b-form-checkbox inline v-model="save_printer" unchecked-value="0" value="1">Save Printer</b-form-checkbox>
          <b-input-group class="text-nowrap">
            <template #append>
              <b-button size="sm" @click="print" variant="outline-primary" style="min-width: 80px">
                Print
              </b-button>
            </template>
            <printer-select v-model="printer" type="LabelLocation" setting="printers.location" ref="printer_select"/>
          </b-input-group>
        </modal-row>
      </div>
    </div>
  </modal>
</template>

<style scoped>

</style>